import { SimpleSlider } from '@/app/components/shared/form/slider/SimpleSlider';
import { Stack } from '@mantine/core';
import { useFormContext } from '../../../contexts/formContext';
import { SettingTitle } from '../../../components/SettingTitle';

const path = 'assetSimplification.topologySettings.vertexMergingDistance';

const marks = [
  { value: 0, label: '0' },
  { value: 0.05, label: '0.05' },
  { value: 0.1, label: '0.1' },
];

export function VertexMergingDistance() {
  const form = useFormContext();
  return (
    <Stack gap='xs'>
      <SettingTitle
        title='Vertex Merging Distance'
        description='Choose maximum reference distance (w.r.t.normalized bounding box) for
        vertex merging'
      />
      <SimpleSlider min={0} max={0.1} step={0.001} marks={marks} w={400} {...form.getInputProps(path)} />
    </Stack>
  );
}
